import { VideoSettingsData, IFieldDisplayData } from "widgets/commonDataObjects/interfaces";
import { SiteItemData } from "widgets/interfaces";
import { MultiImagesItemFrontMobile } from "./frontItemMobile";
import { ArticleData } from "articlePage/stateInterfaces";
import { PromoCarousel } from "../../newYnetTvVerticalDynamic/components/promoCarousel";
import { PromoCarouselLtr } from "../../../newYnetLTRTvVerticalDynamic/components/promoCarouselLtr";

interface MultiImagesFrontProps {
    itemList: SiteItemData[]
    width: number
    fieldsDisplaySettings: IFieldDisplayData
    videoSettings: VideoSettingsData
    imageWidth: number
    imageHeight: number
    titleColor: string
    isYplusComp?: boolean
    displayType: string
    isSpecial?: boolean
    isImageOnly?: boolean
    getArticle(articleId: string): ArticleData
    isLTR?: boolean
    isImageCircle?: boolean
}

const IMAGE_CIRCLE_CARD_WIDTH = 269
const IMAGE_CIRCLE_CARD_GAP = 14

export class MultiImages1280FrontMobile extends React.Component<MultiImagesFrontProps, {}> {
    public static siteScriptName = "MultiImages1280FrontMobile";

    public render() {
        const { imageWidth, itemList, imageHeight, videoSettings, fieldsDisplaySettings, titleColor, isYplusComp, getArticle, displayType, isSpecial, isImageOnly, isLTR, isImageCircle } = this.props
        const className = `slotList ${isImageOnly ? "imageOnly" : ""}`;
        const items = itemList.map((slot, index) => {
            return (
                <MultiImagesItemFrontMobile
                    item={slot}
                    isLTR={isLTR}
                    index={index}
                    isMutamView={true}
                    isSpecial={isSpecial}
                    getArticle={getArticle}
                    imageWidth={imageWidth}
                    titleColor={titleColor}
                    isYplusComp={isYplusComp}
                    imageHeight={imageHeight}
                    displayType={displayType}
                    isImageOnly={isImageOnly}
                    videoSettings={videoSettings}
                    isImageCircle={isImageCircle}
                    fieldsDisplaySettings={fieldsDisplaySettings}
                />
            )
        })

        if (!isImageCircle) return (
            <div className="slotsContent">
                <div className={className}>
                    {items}
                </div>
            </div>
        )

        const Carousel = isLTR ? PromoCarouselLtr : PromoCarousel
        return (
            <Carousel imageWidth={IMAGE_CIRCLE_CARD_WIDTH} marginRight={IMAGE_CIRCLE_CARD_GAP} itemListLength={itemList.length}>
                {items}
            </Carousel>
        )
    }
}
